import { useEffect, useState, useContext } from 'react';
import { LanguageContext } from "../context/LanguageProvider";
import Questions from '../components/Questions';
import { AnimatePresence, motion } from 'framer-motion';

const AdvisorsIdentification = ({
  client,
  product,
  subGroup,
  validationErrors,
  setValidationErrors,
  inputRefs,
  handleInputBlur,
  language,
  setQuestions,
  firstLevelArea,
  secondLevelArea,
  subArea,
  inputBlurTriggered,
  savingQuestionId,
  fetchAreaNames,
  subIndex,
  setIsDataSaved
}) => {

  const { t } = useContext(LanguageContext);

  
  return (
    <div className='advisors-identification'>

      <div className='advisor-labels'>
        <div className='advisor-labels-name'>{t('name')}</div>
        <div className='advisor-labels-code'>Code</div>
        <div className='advisor-labels-percentage'>%</div>
      </div>

       <div className="questions">
      

<AnimatePresence mode="popLayout">
  {subGroup.subAreaCompositionDtoList.map((question) => (
    <motion.div
      key={`question-${question.uniqueId}`}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.2 }}
      className={`${question.compositionType} ${question.uniqueId} ${question.code}`}
    >
      <Questions
        key={question.uniqueId}
        question={question}
        validationErrors={validationErrors}
        setValidationErrors={setValidationErrors}
        inputRefs={inputRefs}
        setQuestions={setQuestions}
        handleInputBlur={handleInputBlur}
        firstLevelArea={firstLevelArea}
        subArea={subArea}
        secondLevelArea={secondLevelArea}
        inputBlurTriggered={inputBlurTriggered}
        savingQuestionId={savingQuestionId}
        fetchAreaNames={fetchAreaNames}
        client={client}
        product={product}
        language={language}
        setIsDataSaved={setIsDataSaved}
      />
    </motion.div>
  ))}
</AnimatePresence>





      </div>



    </div>
  );
};

export default AdvisorsIdentification;
